import React, { Component } from 'react';

const styles = {
  root: {
    cursor: 'pointer',
    border: 0,
    background: 'none',
    padding: 0
  },
  dot: {
    backgroundColor: '#FFFFFF',
    height: 2,
    width: 10,
    marginLeft: 2,
    marginRight: 2,
    opacity: 0.4
  },
  active: {
    opacity: 1
  }
};

class PaginationDot extends Component {
  handleClick = event => {
    this.props.onClick(event, this.props.index);
  };

  render() {
    const { active } = this.props;

    let styleDot;

    if (active) {
      styleDot = Object.assign({}, styles.dot, styles.active);
    } else {
      styleDot = styles.dot;
    }

    return (
      <button
        className={`${active ? 'active' : ''}`}
        style={styles.root}
        onClick={this.handleClick}
      >
        <div style={styleDot} />
      </button>
    );
  }
}

// PaginationDot.propTypes = {
//   active: PropTypes.bool.isRequired,
//   index: PropTypes.number.isRequired,
//   onClick: PropTypes.func.isRequired,
// };

export default PaginationDot;
